import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import LoginLayout from "../template/auth/Layout";

function PublicRoutes({ path, children }: { path: any; children?: any }) {
  return (
    <>
      <LoginLayout props={undefined}>
        <Route exact path={path}>
          {children}
        </Route>
      </LoginLayout>
    </>
  );
}

export default PublicRoutes;
